import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "button"]

    connect() {
        // Only run on mobile/tablet
        if (window.innerWidth >= 992) {
            return
        }
        
        this.checkAllContents()
        
        // Recheck on window resize (debounced)
        this.resizeHandler = this.debounce(() => this.checkAllContents(), 250)
        window.addEventListener('resize', this.resizeHandler)
    }

    disconnect() {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler)
        }
    }

    checkAllContents() {
        // Skip on desktop
        if (window.innerWidth >= 992) {
            this.contentTargets.forEach((content, index) => {
                content.classList.remove('is-clamped', 'is-expanded')
                if (this.buttonTargets[index]) {
                    this.buttonTargets[index].classList.add('d-none')
                }
            })
            return
        }

        this.contentTargets.forEach((content, index) => {
            const button = this.buttonTargets[index]
            const maxLines = parseInt(content.dataset.maxLines) || 2
            
            // Calculate if content exceeds line limit
            if (this.isContentOverflowing(content, maxLines)) {
                content.classList.add('is-clamped')
                if (button) {
                    button.style.display = 'inline-block'
                }
            } else {
                content.classList.remove('is-clamped')
                if (button) {
                    button.classList.add('d-none')
                }
            }
        })
    }

    isContentOverflowing(element, maxLines) {
        // Temporarily remove clamping to measure full height
        const wasClamped = element.classList.contains('is-clamped')
        element.classList.remove('is-clamped')
        
        // Get computed line-height
        const styles = window.getComputedStyle(element)
        const lineHeight = parseFloat(styles.lineHeight)
        
        // Calculate max allowed height (lines * line-height)
        const maxHeight = maxLines * lineHeight
        
        // Get actual content height
        const actualHeight = element.scrollHeight
        
        // Restore clamped state
        if (wasClamped) {
            element.classList.add('is-clamped')
        }
        
        // Return true if content exceeds limit (with small tolerance)
        return actualHeight > maxHeight + 5 // +5px tolerance
    }

    expand(event) {
        event.preventDefault()
        
        const button = event.currentTarget
        const index = this.buttonTargets.indexOf(button)
        const content = this.contentTargets[index]
        
        // Expand content
        content.classList.remove('is-clamped')
        content.classList.add('is-expanded')
        
        // Hide button (no collapse functionality needed)
        button.classList.add('d-none')
    }

    debounce(func, wait) {
        let timeout
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout)
                func(...args)
            }
            clearTimeout(timeout)
            timeout = setTimeout(later, wait)
        }
    }
}
